<template>
    <slot v-if="$slots.default"></slot>
    <slot v-else>
        <u class="text-muted">{{ $t('labels.empty') }}</u>
    </slot>
</template>
<script>
export default {
    name: 'AppNullableCell'
}
</script>